<main role="main">
    <section class="jumbotron" style="background-image: url('../../assets/images/laptop-working-header.jpg');">
        <div class="jumbotron_body">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 col-md-offset-2 text-center">
                        <h1>Matriculación</h1>
                        <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam volutpat vulputate lectus,
                            at maximus massa interdum sed. Etiam vulputate magna ex, nec gravida nisl vestibulum tempus.
                        </p> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay"></div>
    </section>
    <br>
    <div class="container">
        <section>
            <div class="row">
                <div class="col-md-8 col-md-offset-2 ">
                    <div>
                        <section class="panel panel-default panel-border-verde-aloe">
                              <div class="panel-body">
                                <h3 class="text-primary">Datos del Certificado</h3>
                                <hr>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Documento</strong></p>
                                        <p>{{resultado.persona.documento.tipoDocumento.abreviatura}}
                                            {{resultado.persona.documento.numeroDocumento}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Estado</strong></p>
                                        <p *ngIf="resultado.estadoProceso.idEstadoProceso == 1">Proceso Iniciado</p>
                                        <p *ngIf="resultado.estadoProceso.idEstadoProceso == 2">En Proceso de Validación
                                        </p>
                                        <p *ngIf="resultado.estadoProceso.idEstadoProceso == 3">En Proceso de Firma
                                            Digital</p>
                                        <p *ngIf="resultado.estadoProceso.idEstadoProceso == 4" class="text-verde-aloe">
                                            Proceso Finalizado y
                                            Firmado
                                        </p>
                                        <p *ngIf="resultado.estadoProceso.idEstadoProceso == 5" class="text-danger">
                                            Proceso Finalizado con Errores
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Nombres</strong></p>
                                        <p>{{resultado.persona.nombres}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Apellidos</strong></p>
                                        <p>{{resultado.persona.apellidos}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Matrícula</strong></p>
                                        <p>{{resultado.aprobacionProceso.matricula}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Expediente</strong></p>
                                        <p>{{resultado.aprobacionProceso.expediente}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Profesion</strong></p>
                                        <p>{{resultado.aprobacionProceso.profesion.nombre}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Fecha Expedicion</strong></p>
                                        <p>{{resultado.aprobacionProceso.fechaExpedicion}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Fecha Proceso</strong></p>
                                        <p>{{resultado.aprobacionProceso.fechaProceso}}</p>
                                    </div>
                                </div>
                                <h3 class="text-primary">Datos del Firmante</h3>
                                <hr>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Nombre</strong></p>
                                        <p>{{resultado.usuario.nombre}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Apellido</strong></p>
                                        <p>{{resultado.usuario.apellido}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Legajo</strong></p>
                                        <p>{{resultado.usuario.legajo}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Cargo</strong></p>
                                        <p>{{resultado.usuario.cargo}}</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    </div>

</main>